import { compose, withProps, branch, renderComponent, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import SalesRepRow from "./SalesRepresentative";
import SidebarNotAvailable from "../SidebarNotAvailable";
var enhancer = compose(withProps(function (_ref) {
  var salesRep = _ref.salesRep;
  return {
    salesRepresentative: salesRep && salesRep.email
  };
}), branch(function (_ref2) {
  var salesRepresentative = _ref2.salesRepresentative;
  return !salesRepresentative;
}, renderComponent(SidebarNotAvailable)), setPropTypes({
  salesRepresentative: PropTypes.string,
  salesRep: PropTypes.object
}));
export default enhancer(SalesRepRow);